var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3332 24.75L2.6665 30.25V8.25L14.3332 2.75M14.3332 24.75L27.6665 30.25M14.3332 24.75V2.75M27.6665 30.25L39.3332 24.75V2.75L27.6665 8.25M27.6665 30.25V8.25M27.6665 8.25L14.3332 2.75",
    stroke: "#F3F3F3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3332 24.75L2.6665 30.25V8.25L14.3332 2.75M14.3332 24.75L27.6665 30.25M14.3332 24.75V2.75M27.6665 30.25L39.3332 24.75V2.75L27.6665 8.25M27.6665 30.25V8.25M27.6665 8.25L14.3332 2.75",
    stroke: "#FA6138",
    strokeOpacity: 0.48,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoIcon);
export default __webpack_public_path__ + "static/media/geo-icon.371022fe3958cd7af71f7808784320b9.svg";
export { ForwardRef as ReactComponent };